export class CurrencyModel {
  constructor(
    public id?: string,
    public code?: string,
    public name?: string,
    public symbol?: string,
    public isActive?: boolean,
    public createdAt?: string
  ) {}

  public fromJSON(json: any): CurrencyModel {
    if (json) {
      this.id = json.id;
      this.code = json.code;
      this.name = json.name;
      this.symbol = json.symbol;
      this.isActive = json.isActive;
      this.createdAt = json.createdAt;
    }
    return this;
  }

  public fromJSONList(json: any): CurrencyModel[] {
    if (json) {
      return json.map((element: any) => new CurrencyModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      code: this.code,
      name: this.name,
      symbol: this.symbol,
      isActive: this.isActive,
      createdAt: this.createdAt,
    };
  }

  public getId() {
    return this.id ?? '';
  }

  public getReference() {
    return this.code ?? '';
  }

  public getDisplayName() {
    return this.symbol && this.name ? `${this.symbol} ${this.name}` : '';
  }

  public isActiveCurrency() {
    return this.isActive ?? false;
  }
}
